import { render, staticRenderFns } from "./DeletePremiumServiceDialog.vue?vue&type=template&id=3e40741f"
import script from "./DeletePremiumServiceDialog.ts?vue&type=script&lang=ts&external"
export * from "./DeletePremiumServiceDialog.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports